import moment from 'moment';

export function arrayEquals<T>(a: T[], b: T[]) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length != b.length) return false;

    for (var i = 0; i < a.length; ++i) {
        if (a[i] !== b[i]) return false;
    }

    return true;
}

function copyArray(src: any[]) {
    let dst = [];
    for (let i=0 ; i < src.length ; i++) {
        dst.push(copy(src[i]));
    }
    return dst;
}

function copyObject(src: object, props?: string[]) {
    let dst = {};
    for (let k in src) {
        if (src.hasOwnProperty(k) && (!props || props.indexOf(k) != -1)) {
            let v = src[k];
            if (v) {
                if (Array.isArray(v)) {
                    dst[k] = copyArray(v)
                    continue;
                }
                if (typeof v == 'object') {
                    dst[k] = copyObject(v);
                    continue;
                }
            }
            dst[k] = v;
        }
    }
    return dst;
}

export function copy(src: any, props?: string[]) {
    if (src) {
        if (Array.isArray(src)) {
            return copyArray(src);
        }
        if (typeof src == 'object') {
            return copyObject(<object>src, props);
        }
    }
    return src;
}


export type ID = string | number;

export function parseID(id: ID): number {
    switch (typeof id) {
        case 'string':
            return parseInt(<string>id);
        case 'number':
            return <number>id;
        default:
            return 0;
    }
}


export type DateKey = moment.Moment | string;

export function parseDateKey(day: DateKey): moment.Moment  {
    if (!moment.isMoment(day)) {
        day = moment(day, 'YYYY-MM-DD');
    }
    return day;
}


// WEBPACK FOOTER //
// ./src/dndg/helpers/index.ts